import type { ApprovedArtifactVersion } from "./processingTypes";

/** Business-facing Song Play History headline for an artifact version. */
export function songPlayHistoryEventLabel(
  artifact: ApprovedArtifactVersion,
  opts?: { isCurrent?: boolean },
): string {
  const purpose = (artifact.sourceJobPurpose || "").trim();
  if (purpose === "replace-song-audio") return "Song Audio Replaced";
  if (purpose === "reprocess") return "Audio Reprocessed";
  if (purpose === "initial" || artifact.version === 1) {
    return opts?.isCurrent ? "Original Upload" : "Original Upload";
  }
  if (artifact.status === "revoked") return "Playback Revoked (legacy)";
  // Older AAVs without sourceJobPurpose: version 1 is original; later are
  // generic playback updates until provenance is present.
  if (artifact.version <= 1) return "Original Upload";
  return "Playback Updated";
}

/** Operator-facing label for a Processing Job purpose (list/detail history). */
export function processingJobPurposeLabel(job: {
  jobPurpose?: string | null;
  state?: string | null;
  decision?: string | null;
}): string | null {
  const purpose = (job.jobPurpose || "").trim();
  if (purpose !== "replace-song-audio") return null;
  const failed =
    job.state === "failed" ||
    job.decision === "failed" ||
    job.state === "not_approved" ||
    job.decision === "not_approved";
  if (failed) return "Song Audio Replacement Failed";
  if (job.state === "approved" || job.decision === "approved") {
    return "Song Audio Replaced";
  }
  return "Song Audio Replacement";
}
